module.exports = "/_next/static/images/ebd01281b5cfb77ab2029e17f8799b84-amazon-prime-day-mobile.jpg.webp";